module.exports = __webpack_public_path__ + "static/media/avatar_image.49fa2658.png";